import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

const createAxiosInstance = (config?: AxiosRequestConfig<unknown>): AxiosInstance => {
  const instance = axios.create({
    timeout: 30_000, // 30 seconds.
    transitional: {
      clarifyTimeoutError: true,
    },
    ...config,
  });

  return instance;
};

const freshPaintAPI = createAxiosInstance({ baseURL: process.env.FRESHPAINT_API_URL });

export { freshPaintAPI };
